import "./product.css";
import Technology from "./Technology";
import Info from "./Info";

const Product = ({img,id,link,code,tstack,info}) => {
  return (
    <div className="project-card p">
      <div className="p-browser">
        <div className="p-circle"></div>
        <div className="p-circle"></div>
        <div className="p-circle"></div>
      <a className="project-github-link code" rel="noopener noreferrer" href={code} target='_blank'> <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 .3a12 12 0 0 0-3.8 23.4c.6.1.8-.3.8-.6v-2c-3.3.7-4-1.6-4-1.6-.6-1.4-1.4-1.8-1.4-1.8-1-.7.1-.7.1-.7 1.2 0 1.9 1.2 1.9 1.2 1 1.8 2.8 1.3 3.5 1 0-.8.4-1.3.7-1.6-2.7-.3-5.5-1.3-5.5-6 0-1.2.5-2.3 1.3-3.1-.2-.4-.6-1.6 0-3.2 0 0 1-.3 3.4 1.2a11.5 11.5 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.6.2 2.8 0 3.2.9.8 1.3 1.9 1.3 3.2 0 4.6-2.8 5.6-5.5 5.9.5.4.9 1 .9 2.2v3.3c0 .3.1.7.8.6A12 12 0 0 0 12 .3"></path></svg> code </a>
      </div>
      <a href={link} className="project-deployed-link" rel="noopener noreferrer" target="_blank">
        <img src={img} alt="" className="p-img" />
      </a>
      <Info text={info}/>
      <Technology id={id} icons={tstack}/>
      <p className="project-tech-stack">Html, CSS, JavaScript, ReactJS, Redux</p>
    </div>
  );
};

export default Product;
